import React from "react";
import { SEO, Image } from "@bluefin/components";
import { Grid, Segment, Header } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class VipPerksPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.legionhairstudio.com/vip-perks/"}
        />
        <Grid
          className={"custom-page-vip-perks custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"ibknimlddebnedop"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"ifankhpphaomemnm"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__bc660a7d-0c55-4bcb-8666-9b9981541293"}
                >
                  <Grid
                    stackable={true}
                    verticalAlign={"middle"}
                    textAlign={"center"}
                    centered={true}
                    column={"2"}
                  >
                    <Grid.Row stretched={true}>
                      <Header
                        as={"h2"}
                        content={
                          "Fall Into Radiance: September & October VIP Exclusive"
                        }
                      />
                    </Grid.Row>
                    <Grid.Row stretched={true}>
                      <Grid.Column width={8} textAlign={"center"}>
                        <Image
                          size={"big"}
                          centered={true}
                          src={
                            "https://www.legionhairstudio.com/static/81c62a212ab890bcf47ab49fb197a7b2/4f506/large-SeptOct2025_newsletter_1.webp"
                          }
                        />
                      </Grid.Column>
                      <Grid.Column width={8} textAlign={"center"}>
                        <div className={"custom-font-size"}>
                          Fall into radiance with this seasonal favorite!
                          Designed to exfoliate, brighten, and renew, this
                          facial is the ultimate glow-getter.
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"opedpcdmhfloejpj"}
            style={{ padding: 16 }}
            columns={3}
          >
            <Grid.Column className={"fboaamfgpibdellc"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", backgroundSize: "cover" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "5dc44bdf-1499-4a89-8588-39bd7b44c33c",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column className={"mhhnikddfjcaegag"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", backgroundSize: "cover" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "69524ecd-0ae6-4504-841a-b7103798315e",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column className={"mkeenfbpacapecdd"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", backgroundSize: "cover" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "98bee3fa-c46b-41fc-a416-b3d3093bb445",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fagedbkgkhblejnm"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"jlkamolandhdeegk"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__9e2b567f-9b1b-4e35-9750-c6baf1af1b50"}
                >
                  <Grid
                    stackable={true}
                    verticalAlign={"middle"}
                    textAlign={"center"}
                    centered={true}
                    column={"2"}
                  >
                    <Grid.Row stretched={true}>
                      <Header
                        as={"h2"}
                        content={"Seasonal Savings on Salon Essentials"}
                      />
                    </Grid.Row>
                    <Grid.Row stretched={true}>
                      <Grid.Column width={8} textAlign={"center"}>
                        <Image
                          size={"big"}
                          centered={true}
                          src={
                            "https://fisherman.gumlet.io/public/9c8a3021-67da-43fe-a279-c3bf894dcaa2/buy_more_save_more.png"
                          }
                        />
                      </Grid.Column>
                      <Grid.Column width={8} textAlign={"center"}>
                        <div className={"custom-font-size"}>
                          Buy 3 stylers and enjoy 30% off - the perfect way to
                          refresh your product lineup for fall.
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 34222 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
      }
    }
  }
`;
